type PracticeAddress = {
  practice_name?: string | null;
  addline1?: string | null;
  addline2?: string | null;
  addline3?: string | null;
  addline4?: string | null;
  region?: string | null;
  postcode?: string | null;
};

export const arrayToCommaSeparatedString = (arr: unknown[]) => {
  return String(arr.filter(Boolean).join(', '));
};

export const formatPracticeFromObject = (gpDetails: PracticeAddress) => {
  const { practice_name, addline1, addline2, addline3, addline4, region, postcode } = gpDetails;
  return arrayToCommaSeparatedString([practice_name, addline1, addline2, addline3, addline4, region, postcode]);
};
